<template>
  <div id="map-container" class="mb-3"></div>
</template>

<script>
export default {
  data: function() {
    return {
    };
  },
  props: {
    items: {
      type: Array,
      default: [],
    },
  },
  mounted: function() {

    if (typeof google !== 'undefined') {
      const map = new google.maps.Map(document.getElementById('map-container'), {
        center: { lat: 58.23298907932755, lng: 11.748491959175501 },
        zoom: 8,
        mapId: '3435a59e02878daa'
      });

      setTimeout(() => {

        this.items.forEach(item => {
          const contentString =
            `
          <div class="d-flex flex-column flex-md-row">
            <img src="${item.img_popup}" class="mr-2">
            <div>
              <h2 class="text-turquoise text-border">${item.city}</h2>
              <p class="mb-1 fs-16-bold mt-2">${item.address} - ${item.commune} - ${item.city} </p>
              <p class="mt-0 mb-1 fs-17">${item.salesTitle}</p>
              <a href="${item.href}" class="link__arrow fs-17">Mer info</a>
            </div>
          </div>
          `;
          const infowindow = new google.maps.InfoWindow({
            content: contentString,
          });

          const markerImg = document.createElement("img");
          markerImg.src = prekApiSettings.template_path + '/resources/images/map-marker.png';
          markerImg.style.width = '29px';
          markerImg.style.height = '37px';

          const marker = new google.maps.marker.AdvancedMarkerElement({
            position: { lat: item.coordinates['lat'], lng: item.coordinates['lon'] },
            map: map,
            content: markerImg
          });

          marker.addListener('click', () => {
            infowindow.open({
              anchor: marker,
              map,
              shouldFocus: false,
            });
          });
        });

      }, 800);
    }
  },
  name: "viewmap"
}
</script>

<style scoped>
  #map-container {
    width: 100%;
    height: 500px;
    position: relative;
    outline: none;
  }

</style>
